(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["fastbundle-product-template"]) return;
  try {
    
moment.locale("fr")

function addWeekdays(date, days) {
  date = moment(date); // use a clone
  while (days > 0) {
    date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
      days -= 1;
    }
  }
  return date;
}


let btn = $('#AddToCart-product-template')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

let watching_start = Math.floor(Math.random() * (50-10+1) + 10)
$('#marketing_watching_nb').html(watching_start)
setInterval(function(){
	if (Math.random() < 0.5){
    	if(watching_start >= 10){
			watching_start++ 
		}
		else{
			watching_start--
		}
	}
	else{
		if(watching_start <= 50){
			watching_start--
		}
		else{
			watching_start++
		}
	}
	$('#marketing_watching_nb').html(watching_start)
},5000)


let commands_start = Math.floor(Math.random() * (20-1+1) + 1)
$('#marketing_commands_nb').html(commands_start)
setInterval(function(){
	if (Math.random() < 0.5){
		commands_start--                 
	}
	else{
		commands_start++
	}
	$('#marketing_commands_nb').html(commands_start)
},8000);

let arrAvg = arr => arr.reduce((a,b) => a + b, 0) / arr.length
let shipping_time = Math.round(arrAvg([$('#marketing_shipping_day').data('min'),$('#marketing_shipping_day').data('max')]))
console.log(shipping_time)
let shipping_time_to = addWeekdays(moment(),shipping_time)
let shipping_time_text = shipping_time_to.format("dddd DD MMM")
$("#marketing_shipping_day").html(shipping_time_text.charAt(0).toUpperCase() + shipping_time_text.substr(1))

var countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()

var countDownOffer = moment().add(73101,'s').toDate()

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
	var distance = countDownDate - now;
	var distanceOffer = countDownOffer - now;
	let distanceOfferOld = distanceOffer

if (window.localStorage.getItem('countdown_old') == null){
	window.localStorage.setItem('countdown_old',distanceOffer)
}
else{
//console.log(window.localStorage.getItem('countdown_old'),distanceOffer)
	window.localStorage.setItem('countdown_old', distanceOffer)
	distanceOffer = window.localStorage.getItem('countdown_old')
	
}

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var daysOffer = Math.floor(distanceOffer / (1000 * 60 * 60 * 24));
  var hoursOffer = Math.floor((distanceOffer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesOffer = Math.floor((distanceOffer % (1000 * 60 * 60)) / (1000 * 60));
  var secondsOffer = Math.floor((distanceOffer % (1000 * 60)) / 1000);


  // Display the result in the element with id="demo"

	$('#marketing_watching_date').html(hours + "h " + minutes + "mins")

	$('#marketing_countdown_date').html(("0" + daysOffer).slice(-2)+" jours "+ ("0" + hoursOffer).slice(-2) + " heures " + ("0" + minutesOffer).slice(-2) + " minutes "+  ("0" + secondsOffer).slice(-2) + " secondes")


  // If the count down is finished, write some text 
  if (distance < 0) {
    countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()
	countDownOffer = moment().add(1,'d').hours(5).minutes(0).toDate()
  }
}, 1000);
                   
/*$(function(){
if($('#AddToCart-product-template').data('loaderon') == true){
	$('#AddToCart-product-template').click(function(){
		$("#AddToCart-product-template span").html('<center style="padding:0;background:none;"><div class="loader"></div></center>')
	})
}
})*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
let btn = $('button[id^="AddToCart"]')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
moment.locale("fr")

function addWeekdays(date, days) {
  date = moment(date); // use a clone
  while (days > 0) {
    date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
      days -= 1;
    }
  }
  return date;
}


let btn = $('#AddToCart-product-template')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

let watching_start = Math.floor(Math.random() * (50-10+1) + 10)
$('#marketing_watching_nb').html(watching_start)
setInterval(function(){
	if (Math.random() < 0.5){
    	if(watching_start >= 10){
			watching_start++ 
		}
		else{
			watching_start--
		}
	}
	else{
		if(watching_start <= 50){
			watching_start--
		}
		else{
			watching_start++
		}
	}
	$('#marketing_watching_nb').html(watching_start)
},5000)


let commands_start = Math.floor(Math.random() * (20-1+1) + 1)
$('#marketing_commands_nb').html(commands_start)
setInterval(function(){
	if (Math.random() < 0.5){
		commands_start--                 
	}
	else{
		commands_start++
	}
	$('#marketing_commands_nb').html(commands_start)
},8000);

let arrAvg = arr => arr.reduce((a,b) => a + b, 0) / arr.length
let shipping_time = Math.round(arrAvg([$('#marketing_shipping_day').data('min'),$('#marketing_shipping_day').data('max')]))
console.log(shipping_time)
let shipping_time_to = addWeekdays(moment(),shipping_time)
let shipping_time_text = shipping_time_to.format("dddd DD MMM")
$("#marketing_shipping_day").html(shipping_time_text.charAt(0).toUpperCase() + shipping_time_text.substr(1))

var countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()

var countDownOffer = moment().add(73101,'s').toDate()

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
	var distance = countDownDate - now;
	var distanceOffer = countDownOffer - now;
	let distanceOfferOld = distanceOffer

if (window.localStorage.getItem('countdown_old') == null){
	window.localStorage.setItem('countdown_old',distanceOffer)
}
else{
//console.log(window.localStorage.getItem('countdown_old'),distanceOffer)
	window.localStorage.setItem('countdown_old', distanceOffer)
	distanceOffer = window.localStorage.getItem('countdown_old')
	
}

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var daysOffer = Math.floor(distanceOffer / (1000 * 60 * 60 * 24));
  var hoursOffer = Math.floor((distanceOffer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesOffer = Math.floor((distanceOffer % (1000 * 60 * 60)) / (1000 * 60));
  var secondsOffer = Math.floor((distanceOffer % (1000 * 60)) / 1000);


  // Display the result in the element with id="demo"

	$('#marketing_watching_date').html(hours + "h " + minutes + "mins")

	$('#marketing_countdown_date').html(("0" + daysOffer).slice(-2)+" jours "+ ("0" + hoursOffer).slice(-2) + " heures " + ("0" + minutesOffer).slice(-2) + " minutes "+  ("0" + secondsOffer).slice(-2) + " secondes")


  // If the count down is finished, write some text 
  if (distance < 0) {
    countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()
	countDownOffer = moment().add(1,'d').hours(5).minutes(0).toDate()
  }
}, 1000);
                   
/*$(function(){
if($('#AddToCart-product-template').data('loaderon') == true){
	$('#AddToCart-product-template').click(function(){
		$("#AddToCart-product-template span").html('<center style="padding:0;background:none;"><div class="loader"></div></center>')
	})
}
})*/

  } catch(e) { console.error(e); }
})();

})();
